module.exports = __webpack_public_path__ + "static/media/m_hairstyle_quiff_front_shadow.3a9ff0b0.png";